import { styled } from "styled-components";
import { CommonModalWrap } from "../../styles/common";
import theme from "../../styles/theme";
import CommonModalBar from "../common/CommonModalBar";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { getCompanyInfo, useGetTargetClient, useSetClient, useSetClientStorage } from "../../interfaces/clients";
import { formatBizNo, zeroPad } from "../../common/util";
import { useQueryClient } from "react-query";
import { MODAL_QUERY_NM } from "../../interfaces/modal";
import moment from "moment";
import { useGetAuthInfo } from "../../interfaces/auth";
import SearchClient from "./SearchClient";

const DetailWindow = styled.div`
    position: relative;
    background: ${theme.color.white[100]};
    width: 70%;
    height: 70vh;
    border-radius: 18px;
    padding: 1rem 1rem;
`;

const MainBody = styled.div`
    padding: 1.5rem 0rem 1.5rem 0rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
    overflow:auto;
    height: calc(70vh - 40px - 2rem - 40px);

    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
    }
`;

const ButtonBox = styled.div`
    display: flex;
    justify-content: flex-end;
    height: 40px;
    gap: 8px;
`;



const Detail = ({target, close}) => {

    const queryClient = useQueryClient();

    const {mutate} = useSetClient();
    const {mutate: storageMutate} = useSetClientStorage();

    const [sendItem, setSendItem] = useState({});
    const [recvCid, setRecvCid] = useState();
    const [searchModal, setSearchModal] = useState();

    const {data, refetch} = useGetTargetClient(recvCid ? recvCid : target && target.cid);
    const {data: user} = useGetAuthInfo();



    useEffect(()=>{
        data && setSendItem(initSendItem(data[0]));
    },[data])

    useEffect(()=>{
        if(data && recvCid){
            // setSendItem(initSendItem(data[0]));
            refetch();
            setRecvCid(undefined);
        }
    },[data, recvCid])

    const initSendItem = (param) => {
        if(param && param.cid){
            if(param.cid && (param.cs_is_use === -1)){
                if(param.is_cre !== 1){
                    return {
                        ...param,
                        dir_nm: 'T'+zeroPad(param.cid),
                        pass: 'Tdn_'+zeroPad(param.cid),
                        vol_nm: ((!param) ||param.vol_nm===null || param.vol_nm==='') ?'N' : param.vol_nm
                    }
                }else{
                    return param;
                }
            }else{
                if(param.is_cre === 1){
                    return {
                        ...param,
                        vol_nm: ((!param) ||param.vol_nm===null || param.vol_nm==='') ?'N' : param.vol_nm
                    }
                }else{
                    return param;
                }
            }
        }else{
            return {};
        }
    }

    const handleAddClick = useCallback((addItem) => {
        const temp = {
            mode: 'POST',
            ...addItem
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    if(res.data && res.data[res.data.length-1]){
                        const temp = res.data[res.data.length-1];
                        if(temp && temp[0] && temp[0].cid){
                            setRecvCid(temp[0].cid);
                            queryClient.setQueryData(
                                [MODAL_QUERY_NM],
                                {
                                    show:true,
                                    msg:'등록하였습니다.',
                                    height:'20vh',
                                }
                            )
                        }
                    }
                }
            }
            )
    })

    const handleUpdateClick = useCallback((updateItem) => {
        const temp = {
            mode: 'PUT',
            ...updateItem
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'수정하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleDeleteClick = (deleteItem) => {
        queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'삭제하시겠습니까?',
                            height:'20vh',
                            okButton:()=>confirmDelete(deleteItem)
                        }
                    )
    }

    const confirmDelete = useCallback((deleteItem) => {
        const temp = {
            mode: 'DELETE',
            ...deleteItem
        }
        mutate(
            temp,
            {
                onSuccess:()=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'삭제하였습니다.',
                            height:'20vh',
                        }
                    )
                    close(undefined)
                }
            }
            )
    })

    
    const handleSubsClick = (addItem) => {
        if(addItem && addItem.clientId && addItem.clientId.length>3){
            confirmSubs(addItem);
        }else{
            queryClient.setQueryData(
                [MODAL_QUERY_NM],
                {
                    show:true,
                    msg:'아이디를 입력하세요.',
                    height:'20vh',
                }
            )
        }
    }

    const confirmSubs = useCallback((addItem) => {
        const temp = {
            mode: 'SUBS',
            ...addItem,
        }
        storageMutate(
            temp,
            {
                onSuccess:(res)=>{
                            queryClient.setQueryData(
                                [MODAL_QUERY_NM],
                                {
                                    show:true,
                                    msg:'신청하였습니다.',
                                    height:'20vh',
                                }
                            )
                            // close(undefined)
                }
            }
            )
    })

    const handleSubsModClick = (addItem) => {
        if(addItem && addItem.clientId && addItem.clientId.length>3){
            confirmSubsMod(addItem);
        }else{
            queryClient.setQueryData(
                [MODAL_QUERY_NM],
                {
                    show:true,
                    msg:'아이디를 입력하세요.',
                    height:'20vh',
                }
            )
        }
    }

    const confirmSubsMod = useCallback((addItem) => {
        const temp = {
            mode: 'SUBS_MOD',
            ...addItem,
        }
        storageMutate(
            temp,
            {
                onSuccess:(res)=>{
                            queryClient.setQueryData(
                                [MODAL_QUERY_NM],
                                {
                                    show:true,
                                    msg:'신청하였습니다.',
                                    height:'20vh',
                                }
                            );
                            // close(undefined);
                }
            }
            )
    })

    const handleCompleteClick = useCallback((updateItem) => {
        
        const temp = {
            mode: 'COMPLETE',
            ...updateItem,
        }
        storageMutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'수정하였습니다.',
                            height:'20vh',
                        }
                    );
                    // close(undefined);
                }
            }
            )
    })

    const handleValueChange = (id, val) => {
        const temp  = {...sendItem,[id]:val}
        setSendItem(temp);
    }

    const handleCloseClick = () => {
        close(undefined);
    }

    const handleSetSearchInfo = (param) => {
        const temp = {
            ...sendItem,
            cname: param.company,
            biz_no: param.bno,
            owner_nm: param.owner_nm,
            zipcode: param.zipcode,
            addr: param.addr,
            phn_no_o: param.phn_no_o,
            fax_no: param.fax_no,
            biz_tp: param.biz_tp
        }
        setSendItem(temp);
    }

    const callGetCompanyInfo = async () => {
        const companyInfo = await getCompanyInfo(sendItem.biz_no.replaceAll('-',''))
        if(companyInfo.err!==true){
            const temp = {
                ...sendItem,
                owner_nm: companyInfo.owner_nm,
                zipcode: companyInfo.zipcode,
                addr: companyInfo.addr,
                phn_no_o: companyInfo.phn_no_o,
                fax_no: companyInfo.fax_no,
            }
            setSendItem(temp);
        }else{
            queryClient.setQueryData(
                [MODAL_QUERY_NM],
                {
                    show:true,
                    msg:companyInfo.message,
                    height:'20vh',
                }
            );
        }
    }

    return (
        <CommonModalWrap style={{zIndex:1300}}>
            <DetailWindow>
                <CommonModalBar title={sendItem.cid ? '고객사 정보' : '고객사 등록'} close={handleCloseClick}/>
                <MainBody>
                    <div className="row">
                        <TextField 
                            id='cname' 
                            label='고객사명' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            InputProps={{readOnly: true}}
                            value={sendItem.cname ? sendItem.cname : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                        <TextField 
                            id='biz_no' 
                            label='사업자번호' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            InputProps={{readOnly: true}}
                            value={sendItem.biz_no ? formatBizNo(sendItem.biz_no.replaceAll('-','')) : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value.replaceAll('-',''))}
                        />
                        <Button variant='contained' onClick={()=>setSearchModal(true)}>고객사 검색</Button>
                        {sendItem.biz_no && <Button variant='contained' onClick={()=>callGetCompanyInfo()}>고객사 정보 가져오기</Button>}
                    </div>
                    <div className="row">
                        <TextField 
                            id='alias' 
                            label='고객사명(별칭)' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            value={sendItem.alias ? sendItem.alias : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                        <TextField 
                            id='owner_nm' 
                            label='대표명' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            value={sendItem.owner_nm ? sendItem.owner_nm : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                        <TextField 
                            id='phn_no_o' 
                            label='대표 전화번호' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            value={sendItem.phn_no_o ? sendItem.phn_no_o : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                        <TextField 
                            id='fax_no' 
                            label='FAX' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            value={sendItem.fax_no ? sendItem.fax_no : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                    </div>
                    <div className="row">
                        <TextField 
                            id='mangr_nm' 
                            label='담당자명' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            value={sendItem.mangr_nm ? sendItem.mangr_nm : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                        <TextField 
                            id='phn_no_m' 
                            label='담당자 전화번호' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            value={sendItem.phn_no_m ? sendItem.phn_no_m : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                        <TextField 
                            id='email' 
                            label='Email' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            value={sendItem.email ? sendItem.email : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                        <TextField 
                            id='zipcode' 
                            label='우편번호' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            value={sendItem.zipcode ? sendItem.zipcode : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                    </div>
                    <TextField 
                        id='addr' 
                        label='주소' 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        value={sendItem.addr ? sendItem.addr : ''}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <div className="row">
                        <TextField 
                                id='descr' 
                                label='비고' 
                                fullWidth 
                                multiline
                                // disabled 
                                rows={3} 
                                size='small' 
                                InputLabelProps={{shrink:true}} 
                                value={sendItem.descr ? sendItem.descr : ''}
                                onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                        <TextField 
                                id='memo' 
                                label='메모' 
                                fullWidth 
                                multiline
                                // disabled 
                                rows={3} 
                                size='small' 
                                InputLabelProps={{shrink:true}} 
                                value={sendItem.memo ? sendItem.memo : ''}
                                onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                    </div>
                    <ButtonBox>
                        {(!sendItem.cid) && <Button variant='contained' onClick={()=>handleAddClick(sendItem)}>등록</Button>}
                        {(sendItem && sendItem.cid) && <Button variant='contained' onClick={()=>handleUpdateClick(sendItem)}>수정</Button>}
                        {(sendItem && sendItem.cid) && <Button variant='contained' onClick={()=>handleDeleteClick(sendItem)}>삭제</Button>}
                    </ButtonBox>
                    <div className="row">
                        <span style={{fontSize:theme.fontSize.bmd}}>고객사 계정정보 ({(sendItem.is_cre !== 1) ? '미발급' : '발급완료'})</span>
                    </div>
                    <div className="row">
                        <TextField 
                            id='clientId' 
                            label='ID' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            value={sendItem.clientId ? sendItem.clientId : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                        <TextField 
                            id='pass' 
                            label='PASSWORD' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            value={sendItem.pass ? sendItem.pass : ''}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                        <TextField 
                            id='dir_nm' 
                            label='폴더명' 
                            size='small' 
                            InputLabelProps={{shrink:true}}
                            disabled
                            value={sendItem.dir_nm ? sendItem.dir_nm : ''}
                        />
                        <FormControl style={{width:'10rem'}} size='small'>
                            <InputLabel id='vol_nm-label'>볼륨명</InputLabel>
                            <Select label="볼륨명" labelId='vol_nm-label' size='small' value={sendItem.vol_nm ? sendItem.vol_nm : 'N'}>
                                <MenuItem value={'N'} onClick={()=>handleValueChange('vol_nm','N')} >미배정</MenuItem>
                                <MenuItem value={'volume5'} onClick={()=>handleValueChange('vol_nm','volume5')} >volume5</MenuItem>
                                <MenuItem value={'volume4'} onClick={()=>handleValueChange('vol_nm','volume4')} >volume4</MenuItem>
                                <MenuItem value={'volume3'} onClick={()=>handleValueChange('vol_nm','volume3')} >volume3</MenuItem>
                                <MenuItem value={'volume2'} onClick={()=>handleValueChange('vol_nm','volume2')} >volume2</MenuItem>
                            </Select>
                        </FormControl>
                        {/* <TextField 
                            id='vol_nm' 
                            label='볼륨명' 
                            size='small' 
                            InputLabelProps={{shrink:true}} 
                            disabled={!(user.user_tp === 'A')}
                            value={sendItem.vol_nm ? sendItem.vol_nm : ''}
                        /> */}
                    </div>
                    <div className="row">
                    {(sendItem.cs_is_use === -1) ? 
                        <Button variant='contained' onClick={()=>handleSubsClick(sendItem)}>계정생성 신청</Button>
                        :
                        <React.Fragment>
                            <TextField
                                id='cs_reg_dt' 
                                label='신청(변경신청)일' 
                                size='small' 
                                InputLabelProps={{shrink:true}}
                                disabled
                                value={sendItem.cs_reg_dt ? sendItem.cs_reg_dt : ''}
                            />
                            {sendItem.is_cre === 1 &&
                                <TextField
                                    id='cre_dt' 
                                    label='생성(변경)일' 
                                    size='small' 
                                    InputLabelProps={{shrink:true}}
                                    disabled
                                    value={sendItem.cre_dt ? sendItem.cre_dt : ''}
                                />
                            }
                            <Button variant='contained' onClick={()=>handleSubsModClick(sendItem)}>계정정보 변경신청</Button>
                        </React.Fragment>
                    }
                    {(user && user.user_tp === 'A') &&
                            <Button variant='contained' onClick={()=>handleCompleteClick(sendItem)}>생성 및 변경완료</Button>
                    }
                    </div>
                </MainBody>
                {(searchModal===true) && <SearchClient setSearchInfo={handleSetSearchInfo} close={()=>setSearchModal(false)}/>}
            </DetailWindow>
        </CommonModalWrap>
    )

}

export default Detail;